export default class StudentsDashboardIndex {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    
  }
}